import React, { useContext } from 'react';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';
import { OrderProduct } from './OrderProduct';

const ServiceOrderList = (props) => {
  const { showTotal, orderProducts } = props;
  const [placeState] = useContext(PlaceStoreContext);

  const {
    products: { productId__product },
    toppings: { toppingId__topping },
  } = placeState;

  const productListMap = new Map();
  let total = 0;

  for (const productId in orderProducts) {
    const toppings = [];
    for (const product of orderProducts[productId]) {
      const { productId } = product;

      if (productListMap.has(productId)) {
        const existingProduct = productListMap.get(productId);
        productListMap.set(productId, {
          product: productId__product[productId],
          count: existingProduct.count + 1,
          toppings: [],
        });
      } else {
        productListMap.set(productId, {
          product: productId__product[productId],
          count: 1,
        });
      }
      total += productId__product[productId].cost;
      const toppingsWithData = [];
      for (const toppingId of product.toppingsIds) {
        toppingsWithData.push(toppingId__topping[toppingId]);
        total += toppingId__topping[toppingId].cost;
      }
      toppings.push(toppingsWithData);
    }
    const existingProduct = productListMap.get(productId);
    if (!existingProduct) continue;
    productListMap.set(productId, {
      product: existingProduct.product,
      count: existingProduct.count,
      toppings,
    });
  }

  const productList = Array.from(productListMap.values());

  return (
    <>
      {productList.map((data) => {
        return <OrderProduct key={data.product.id} productData={data} />;
      })}
      {showTotal && (
        <p className="f3b f08 ta-c txt-black p-16"><span className="f3 f07">TOTAL:</span>{` ${total} `.toUpperCase()}<span className="f3 f07">{productList[0]?.product?.currency}</span></p>
      )}
    </>
  );
};

export default ServiceOrderList;
